<template lang="pug">
  div#home
    MainHeader
    MainSlideShow
    hr
    div
      div.tesla-quote-text
        strong “If you want to find the secrets of the universe, think in terms of energy, frequency and vibration.”
      div.tesla-quote-legend
        i – Nikola Tesla
    hr
    TopicCardContainer(:topic_cards="topic_cards")
    Partners
    Footer
</template>

<script>
// @ is an alias to /src
import MainHeader from "@/components/MainHeader.vue";
import MainSlideShow from "@/components/MainSlideShow.vue";
import Footer from "@/components/Footer.vue";
import TopicCardContainer from "@/components/TopicCardContainer.vue";
import Partners from '@/components/Partners.vue';

export default {
  name: 'home',
  components: {
    MainHeader,
    MainSlideShow,
    TopicCardContainer,
    Partners,
    Footer,
  },
  data: function () {
    return {
      baseUrl: process.env.BASE_URL,
      topic_cards:  [
        {
          title: "Services",
          image_name: this.get_image_full_path('maintopiccards/SAM_0559.jpg'),
          content: "",
          has_link_button: true,
          button_text: "Read more...",
          button_link: "/services",
        },
        {
          title: "Products",
          image_name: this.get_image_full_path('maintopiccards/SAM_1005.jpg'),
          content: "",
          has_link_button: true,
          button_text: "Read more...",
          button_link: "/products",
        },
        {
          title: "R&D",
          image_name: this.get_image_full_path('maintopiccards/58.jpg'),
          content: "",
          has_link_button: true,
          button_text: "Read more...",
          button_link: "/rnd",
        },
        
      ]
    };
  },

  methods: {
    get_image_full_path: function(image_subpath) {
      return '/img/' + image_subpath;
    }
  }
}
</script>

<style scoped>
.tesla-quote-text {
  padding:  1rem;
}

.tesla-quote-legend {
  padding: 0.5rem;
}

hr {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    border-bottom-width: 80%;
    margin-bottom: 2rem;
}

.grey {
    background-color: #E8E8E8;
}
</style>
